import React, { useEffect, useRef } from "react";
import { Tooltip } from "@shopify/polaris";
import type { TooltipProps } from "@shopify/polaris";

export default function HoverTooltip({ children, ...props }: TooltipProps): React.ReactElement {
  const activator = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    // Polaris makes its activator tabbable after rendering.
    activator.current.tabIndex = -1;
  });

  return (
    <Tooltip {...props}>
      <span ref={activator} tabIndex={-1}>
        {children}
      </span>
    </Tooltip>
  );
}
